import { render, staticRenderFns } from "./NewContract.vue?vue&type=template&id=365e4ac2&"
import script from "./NewContract.vue?vue&type=script&lang=js&"
export * from "./NewContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports